import { useEffect, useState } from 'react';
import { CreateTestScreen } from './screens/createTestScreen';
import { CreatorDashboardScreen } from './screens/creatorDashboardScreen';
import { AdminConsoleScreen } from './screens/adminConsoleScreen';
import { MyTestsScreen } from './screens/myTestsScreen';
import { ViewerSessionFlow } from './screens/viewerSessionFlow';

const VIEWER_PATH = /^\/t\/([A-Za-z0-9_-]{1,64})\/?$/;
const DASHBOARD_PATH = /^\/d\/([A-Za-z0-9_-]{1,64})\/?$/;

// Three routes, hand-rolled.
//
// A router library would be a dependency (spec §2 lists what v0 installs, and a
// router is not on it) for three static patterns and a popstate listener. Both
// secrets in this product are URL-borne, so the only routing requirement is that
// a pasted link resolves — there are no nested layouts, no guards, no loaders.
export function AppRouter() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const viewerMatch = VIEWER_PATH.exec(path);
  if (viewerMatch?.[1]) return <ViewerSessionFlow testId={viewerMatch[1]} />;

  const dashboardMatch = DASHBOARD_PATH.exec(path);
  if (dashboardMatch?.[1]) return <CreatorDashboardScreen dashboardKey={dashboardMatch[1]} />;

  // The create flow moved off `/` so that `/` could become a server-rendered,
  // indexable landing page (Cowork006 §1). `/` never reaches this router in
  // production — the server answers it — but it is handled here so `vite dev`,
  // which has no server-rendered pages, still lands somewhere sensible.
  if (path === '/my' || path === '/my/') return <MyTestsScreen />;
  if (path === '/admin' || path === '/admin/') return <AdminConsoleScreen />;
  if (path === '/create' || path === '/create/') return <CreateTestScreen />;
  if (path === '/' || path === '') return <CreateTestScreen />;

  return (
    <main className="pageWrap">
      <h1>Nothing here</h1>
      <p className="pageSub">
        That address doesn't match anything. If someone sent you a link, check it copied
        in full — dashboard links in particular are long and get truncated by chat apps.
      </p>
      <a className="buttonSecondary" href="/">
        Start a new test
      </a>
    </main>
  );
}
